module.exports = __webpack_public_path__ + "img/personality.56cb8767.svg";